import { useMagicKeys, whenever } from '@vueuse/core';

function getMetaKey() {
  if (typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator?.userAgent)) {
    return 'Cmd';
  } else {
    return 'Ctrl';
  }
}

export function useCmdK(cb) {
  const keys = useMagicKeys();
  const MetaK = keys[`${getMetaKey()}+K`];

  whenever(MetaK, cb);
}
